import type { Department } from '@common/types';

export const DEPARTMENT_ID = {
  FRONT_DESK: 'dept-front-desk',
  HOUSEKEEPING: 'dept-housekeeping',
  MAINTENANCE: 'dept-maintenance',
  FOOD_BEVERAGE: 'dept-food-beverage',
  SPA_WELLNESS: 'dept-spa-wellness',
  GUEST_RELATIONS: 'dept-guest-relations',
} as const;

export const DEPARTMENTS_SEED: readonly Department[] = [
  {
    id: DEPARTMENT_ID.FRONT_DESK,
    name: 'Front Desk',
    icon: 'room_service',
    tone: 'brand',
    description: 'Reception, check-in / check-out, concierge requests, and lobby coordination.',
    isEnabled: true,
    isSeeded: true,
  },
  {
    id: DEPARTMENT_ID.HOUSEKEEPING,
    name: 'Housekeeping',
    icon: 'cleaning_services',
    tone: 'info',
    description: 'Room servicing, linen, turn-down, lost & found, and cleanliness escalations.',
    isEnabled: true,
    isSeeded: true,
  },
  {
    id: DEPARTMENT_ID.MAINTENANCE,
    name: 'Maintenance',
    icon: 'build',
    tone: 'warning',
    description: 'Building, plumbing, electrical, HVAC, and in-room equipment repairs.',
    isEnabled: true,
    isSeeded: true,
  },
  {
    id: DEPARTMENT_ID.FOOD_BEVERAGE,
    name: 'Food & Beverage',
    icon: 'restaurant',
    tone: 'success',
    description: 'Restaurant, bar, room service, mini-bar, and dining-experience issues.',
    isEnabled: true,
    isSeeded: true,
  },
  {
    id: DEPARTMENT_ID.SPA_WELLNESS,
    name: 'Spa & Wellness',
    icon: 'spa',
    tone: 'neutral',
    description: 'Spa bookings, treatments, pool, gym, and wellness amenities.',
    isEnabled: true,
    isSeeded: true,
  },
  {
    id: DEPARTMENT_ID.GUEST_RELATIONS,
    name: 'Guest Relations',
    icon: 'support_agent',
    tone: 'danger',
    description: 'Complaints, escalations, recovery offers, and VIP coordination.',
    isEnabled: true,
    isSeeded: true,
  },
];
